export interface RuntimeConfig {
  gateUrl: string;
  authUrl: string;
  defaultRegion: string;
  defaultTenant?: string;
  /**
   * Per-cluster feature flags. Each flag toggles a top-level nav section
   * on/off. When false, the section is not rendered AND its lazy chunk is
   * not fetched.
   *
   * Flip by injecting into window.__VEX_CONFIG__ from docker-entrypoint
   * (VEX_ENABLE_UWF_STREAMING=true, etc.) — reload the container to pick
   * up a change.
   *
   * antifraud / incident-mgr flags were removed when those sections were
   * split into standalone console apps (antifraud-console,
   * incident-mgr-console). The core console no longer bundles them.
   */
  enableUwfStreaming?: boolean;
}

declare global {
  interface Window {
    __VEX_CONFIG__?: Partial<RuntimeConfig>;
  }
}

function boolFlag(v: unknown, fallback: boolean): boolean {
  if (typeof v === 'boolean') return v;
  if (typeof v === 'string') return v === '1' || v.toLowerCase() === 'true';
  return fallback;
}

export function readRuntimeConfig(): RuntimeConfig {
  const w = typeof window !== 'undefined' ? window.__VEX_CONFIG__ : undefined;
  const out: RuntimeConfig = {
    gateUrl: w?.gateUrl ?? '/api',
    authUrl: w?.authUrl ?? '/api/auth',
    defaultRegion: w?.defaultRegion ?? 'kz-north-1',
    // Defaults: OFF for prod safety. Dev/qzp override at container start
    // via docker-entrypoint injection.
    enableUwfStreaming: boolFlag(w?.enableUwfStreaming, false),
  };
  if (w?.defaultTenant) out.defaultTenant = w.defaultTenant;
  return out;
}
